<template>
	<div id="header-fixed" class="header-light header-transparent">
		<!--
		<a class="header-icon-left menu-icon open-left-sidebar" href="#"
			><font-awesome-icon icon="fa-solid fa-bars" /> Menú</a
		>
		-->
		<router-link to="/" class="header-icon-left menu-icon open-left-sidebar">
			<font-awesome-icon icon="fa-solid fa-bars" /> Menú
		</router-link>
		<!--
		<a class="header-logo" href="/Home/Index">
			<img
				src="../assets/images/logo.png"
				class="header-logo"
				data-displaymode="Original"
				title="logo"
			/>
		</a>
		-->
		<router-link to="/" class="header-logo">
			<img
				src="../assets/images/logo.png"
				class="header-logo"
				data-displaymode="Original"
				title="logo"
			/>
		</router-link>

		<router-link to="/mi-perfil" class="header-icon-three user-icon">
			<font-awesome-icon icon="fa-solid fa-user" />
		</router-link>

		<a
			@click="cerrarSesion"
			title="Cerrar Sesión"
			href="javascript:;"
			class="header-icon-right logout-icon">
			<font-awesome-icon icon="fa-solid fa-power-off"	/>
		</a>
		<div class="header-menu-overlay"></div>
		<div class="header-menu header-menu-dark"></div>
	</div>
</template>

<script>
    export default {
        name: "Encabezado",
		methods:{
			cerrarSesion:function(){
				this.$store.commit('cerrarSesion');
				this.$store.commit('limpiarPerfil');
			}
		}
    };
</script>

<style scoped></style>
